import React, { useState, useRef } from "react";
import gift from 'assets/img/bluegift.jpg'
import message from 'assets/img/message.jpg'
import chart from 'assets/img/chart.png'
import search from 'assets/img/search.jpg';
import SearchIcon from '@material-ui/icons/Search';
import { toast } from "react-toastify";
import { useHistory } from 'react-router-dom';
import upgardeloyalty from 'apis/UpgradeLoyalty/upgardeloyalty';
import logo from 'assets/img/henry-schein-logo-png-transparent.png'
import sidelogo from 'assets/img/HS_Thrive Unlocked__Lockup.png'
import unlock from 'assets/img/HS_Thrive Unlocked__K.O.png'

export default function ThriveUnlockedStatusEligibility({
  setNext,
}) {
  const [showDetails, setShowDetails] = useState(false);
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [checked, setChecked] = useState(false);
  const [shipto, setShipto] = useState(localStorage.getItem('shipto'));
  const [name, setName] = useState(localStorage.getItem('practicename'));
  const [link, setLink] = useState(localStorage.getItem('unlocklink'));
  const [email, setEmail] = useState('');
  const [type, settype] = useState('');
  const [signature, setsignature] = useState('');
  const history = useHistory();
  const { getunlockedcreation } = upgardeloyalty();
  const [firstname, setFirstName] = useState('');
  const [lastname, setLastName] = useState('');
  const [loading, setLoading] = useState(false);

  /* =========================
      SIGNATURE - DESKTOP
  ========================== */

  const startDraw = (e) => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    setDrawing(true);
  };

  const draw = (e) => {
    if (!drawing) return;
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 2;
    ctx.stroke();
  };

  const stopDraw = () => {
    setDrawing(false);
  
    if (canvasRef.current) {
      const dataURL = canvasRef.current.toDataURL("image/png");
      setsignature(dataURL); // ✅ store in state
    }
  };

  const clearSignature = () => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    setsignature(""); // ✅ clear state also
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  console.log(localStorage.getItem('practicename'),"name")

  console.log(localStorage.getItem('unlocklink'),"link")





  const handleSubmit = async () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  
    const isEmpty = !pixels.some(p => p !== 0);

    if(isEmpty || !shipto || !name || !email ||!checked ||!firstname || !lastname) {
      return toast.error("Please complete the required information to continue.");

    }
  
    // ✅ FIXED
    if (isEmpty) {
      return toast.error("Please provide signature");
    }
  
    if (!shipto) {
      return toast.error("Please Enter the account number");
    }
  
    if (!name) {
      return toast.error("Please Enter the name");
    }

    if (!firstname) {
      return toast.error("Please Enter the first name");
    }

    if (!lastname) {
      return toast.error("Please Enter the last name");
    }
  
    if (!email) {
      return toast.error("Please Enter the email");
    }

    if (!emailRegex.test(email)) {
      return toast.error("Please enter valid email");
    }
  
    if (!checked) {
      return toast.error("Please check terms & conditions");
    }
  
    const dataURL = canvas.toDataURL("image/png");
    setsignature(dataURL);
  
    try {
      setLoading(true);
      let values = {
        henryscheinaccount: shipto,
        practiceName:name,
        email:email,
        signature:signature,
        type:"Eligibility",
        firstname:firstname,
        lastname:lastname
      };
  
      let res = await getunlockedcreation(values);
      console.log(res?.data, "data");
  
      if (res.result_status == 0) {
        setLoading(false);
        return toast.error(res.message);
      }
  
      if (res.result_status == 1) {
        setLoading(false);
        // if (res?.data?.unlock_status == "Unlocked") {
          setNext('4')
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        // }
  
        // if (res?.data?.unlock_status == "Eligibility") {
        //   history.push("thrive-unlocked-eligibility-review");
        // }
      }
    } catch (err) {
      setLoading(false);
      console.log({ err });
    }
  };
  return (
    <>
      <style>{mobileCss}</style>

      <div style={styles.page}>
        {/* HEADER */}

        <div style={styles.fullHeader}>
          <div style={styles.headerContent}>
            <img
              src={logo}
              style={styles.logo}
              alt="logo"
            />

            <img
              src={sidelogo}
              style={styles.rightLogo}
              alt="sidelogo"
            />
          </div>
        </div>

        {/* CARD */}

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <img
              src={unlock}
              style={styles.unlockLogo}
              alt="unlock"
            />
          </div>

          <div style={styles.content}>
            <h2 style={styles.title}>
            Review & Accept
            </h2>

            <p style={styles.subtitle}>
            You’re one step away from submitting your request for Thrive Unlocked.
            </p>

            {/* ALERT */}

            <div style={styles.alert}>
              <div style={styles.alertIcon}>
                i
              </div>

              <div>
                <div style={styles.alertTitle}>
                Eligibility Review Required
                </div>

                <div style={styles.alertText}>
                We need to review your account before enrollment can be completed. You may continue below to submit your request for review.
                </div>

                {/* <div style={styles.alertText}>
               
                </div> */}
              </div>
            </div>

            {/* WHAT TO EXPECT */}

            <div style={styles.expectTitle}>
            What to Expect
            </div>

            <div
              className="expect-container"
              style={styles.expectContainer}
            >
              <ExpectItem
                img={search}
                title="We’ll review your account."
                desc="Our team will review your account and confirm whether your location is eligible for Thrive Unlocked."
              />

              <div
                className="divider-mobile"
                style={styles.verticalDivider}
              />

              <ExpectItem
                img={message}
                title="We’ll Email You an Update"
                desc="You’ll receive an email with your enrollment status and next steps."
              />

              <div
                className="divider-mobile"
                style={styles.verticalDivider}
              />

              <ExpectItem
                img={gift}
                title="Benefits Begin After Approval"
                desc="Once approved, your available Thrive Signature benefits will become active, and you can begin earning Growth Bonus Points."
              />
            </div>

            {/* FORM */}

            <div style={styles.sectionTitle}>
              Confirm Your Details
            </div>

            <label style={styles.label}>
  Henry Schein Account Number{" "}
  <span style={{ color: "red" }}>*</span>
</label>

<input
  placeholder="Location Account Number"
  style={styles.input}
  value={shipto}
  type="text"
  disabled ={true}
  inputMode="numeric"
  onChange={(e) => {
    const value = e.target.value;

    // allow only numbers
    if (/^\d*$/.test(value)) {
      setShipto(value);
    }
  }}
/>

          <label style={styles.label}>Practice Name  <span style={{ color: 'red' }}>*</span></label>
              <input
      style={styles.input}
      type="text"
      value={name}
      disabled={true}
      onChange={(e) => {
        const value = e.target.value;

        // ✅ allow only letters and space
        if (/^[A-Za-z\s]*$/.test(value)) {
          setName(value);
        }
      }}
    />

<div style={styles.nameRow}>
  <div style={styles.fieldGroup}>
    <label style={styles.label}>
      First Name <span style={{ color: "red" }}>*</span>
    </label>

    <input
      style={styles.input}
      // disabled={true}
      type="text"
      value={firstname}
      onChange={(e) => {
        const value = e.target.value;

        // ✅ allow only letters and spaces
        if (/^[A-Za-z\s]*$/.test(value)) {
          setFirstName(value);
        }
      }}
    />
  </div>

  <div style={styles.fieldGroup}>
    <label style={styles.label}>
      Last Name <span style={{ color: "red" }}>*</span>
    </label>

    <input
      style={styles.input}
      // disabled={true}
      type="text"
      value={lastname}
      onChange={(e) => {
        const value = e.target.value;

        // ✅ allow only letters and spaces
        if (/^[A-Za-z\s]*$/.test(value)) {
          setLastName(value);
        }
      }}
    />
  </div>
</div>

          <label style={styles.label}>Email  <span style={{ color: 'red' }}>*</span></label>
          <input style={styles.input}  value ={email} onChange={(e) => setEmail(e.target.value)} />

          <span style={styles.emaillabel}>We’ll send your enrollment confirmation and updates to this email.</span>

            {/* TERMS */}

            <div
              style={styles.dropdownHeader}
              onClick={() =>
                setShowDetails(
                  !showDetails
                )
              }
            >
              <div>
                <div
                  style={styles.dropdownTitle}
                >
                  Program Terms & Details.
                </div>

                <div
                  style={
                    styles.dropdownSubText
                  }
                >
                  Please review the program
                  terms and details
                </div>
              </div>

              <span style={styles.arrow}>
                {showDetails ? "▲" : "▼"}
              </span>
            </div>

            {showDetails && (
              <div style={styles.termsBox}>
                <p>
                <b>Note:</b> Customers approved for Thrive Unlocked will receive access to Thrive Signature benefits. Additional premium Thrive Signature benefits activate after $500 in qualifying invoiced merchandise spend.
                </p>

                <p>
                Customers will also earn $500 in Thrive Rewards Growth Bonus Points for every $5,000 in qualifying invoiced merchandise spend, beginning at $10,000 and up to $110,000. Exclusions apply, including OraPharma/Arestin, Colgate products, small equipment, handpieces, pharmaceuticals, refurbished equipment, service-related fees, and other non-qualifying items.
                </p>

                 <p>
                Points are non-transferable, have no cash value, and may be redeemed for up to 50% of the cost of eligible products on invoices posted 90 days before the redemption date. Points expire at the end of the fiscal month, 24 months after the month in which they are earned. Henry Schein reserves the right to modify or cancel this program at any time.
                </p>
              </div>
            )}

            {/* CHECKBOX */}

            <div
              className="checkbox-mobile"
              style={styles.checkboxRow}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() =>
                  setChecked(!checked)
                }
              />

<             span
                style={styles.checkboxText}
              >
              I agree to submit this Thrive Unlocked request and accept the Terms and Conditions of the <a style={{ textDecoration: "underline" }} href={link} target="_blank"
                            rel="noopener noreferrer"> Thrive Unlocked Service Agreement </a><span style={{ color: 'red' }}>*</span>
              </span>
            </div>

            {/* SIGNATURE */}

            <div style={styles.signatureTitle}>
  Signature
  <span style={{ color: "red" }}> *</span>
</div>

{/* <div style={styles.signText}>
  Sign Here
</div> */}

<canvas
  ref={canvasRef}
  width={500}
  height={120}
  style={styles.canvas}

  /* DESKTOP */
  onMouseDown={startDraw}
  onMouseMove={draw}
  onMouseUp={stopDraw}
  onMouseLeave={stopDraw}

  /* MOBILE TOUCH SUPPORT */
  onTouchStart={(e) => {
    e.preventDefault();

    const touch = e.touches[0];

    const rect =
      canvasRef.current.getBoundingClientRect();

    const fakeEvent = {
      nativeEvent: {
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top,
      },
    };

    startDraw(fakeEvent);
  }}

  onTouchMove={(e) => {
    e.preventDefault();

    const touch = e.touches[0];

    const rect =
      canvasRef.current.getBoundingClientRect();

    const fakeEvent = {
      nativeEvent: {
        offsetX: touch.clientX - rect.left,
        offsetY: touch.clientY - rect.top,
      },
    };

    draw(fakeEvent);
  }}

  onTouchEnd={stopDraw}
/>

<button
  style={styles.clearBtn}
  onClick={clearSignature}
>
  Clear Signature
</button>
            {/* BUTTON */}


                      <button
            style={{
              ...styles.button,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Loading..." : "Submit for Review"}
          </button>

            
            <span style={styles.labelnew}>
              By filling out this form, you consent to allow Henry Schein,Inc. to store and process the information submitted for marketing and other services.
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

/* EXPECT ITEM */

const ExpectItem = ({
  img,
  title,
  desc,
}) => (
  <div style={styles.expectItem}>
    <img
      src={img}
      alt="benefit"
      style={styles.iconCircle}
    />

    <div style={styles.expectItemTitle}>
      {title}
    </div>

    <div style={styles.expectDesc}>
      {desc}
    </div>
  </div>
);

/* STYLES */

const styles = {
   page: {
  background: "#eef1f5",
  minHeight: "100vh",
  margin: 0,
  padding: "16px",
  fontFamily: "Arial, sans-serif",
  overflowX: "hidden",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
},

  fullHeader: {
  width: "100%",
  maxWidth: "520px",
  background: "#fff",
  padding: "10px 16px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  margin: "0 auto 20px auto",
  boxSizing: "border-box",
  borderRadius: "10px",
},

  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "10px",
  },

  logo: {
    width: "120px",
    objectFit: "contain",
  },

  rightLogo: {
    width: "180px",
    maxWidth: "100%",
    objectFit: "contain",
  },

  card: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto",
    background: "#fff",
    borderRadius: "14px",
    boxShadow:
      "0 6px 18px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },

  cardHeader: {
    background: "#0A72BA",
    textAlign: "center",
  },

  unlockLogo: {
    width: "100%",
    maxWidth: "260px",
    objectFit: "contain",
  },

  content: {
    padding: "20px",
  },

  title: {
    textAlign: "center",
    color: "#0E176D",
  },

  subtitle: {
    textAlign: "center",
    fontSize: "13px",
    marginBottom: "20px",
    color: "#343F88",
    lineHeight: "20px",
  },

  alert: {
    display: "flex",
    gap: "14px",
    padding: "16px",
    border: "1px solid #f3d17a",
    borderRadius: "8px",
    background: "#fffaf0",
  },

  alertIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    border: "2px solid #f0b400",
    color: "#f0b400",
    display: "grid",
    placeItems: "center",
    fontWeight: "700",
    flexShrink: 0,
  },

  alertTitle: {
    color: "#0E176D",
    fontSize: "14px",
    fontWeight: "700",
    marginBottom: "6px",
  },

  alertText: {
    color: "#30364d",
    fontSize: "13px",
    lineHeight: "20px",
  },

  expectTitle: {
    fontWeight: "bold",
    marginBottom: "10px",
    marginTop: "16px",
    color: "#0E176D",
  },

  expectContainer: {
    display: "flex",
    border: "1px solid #dbe3f0",
    borderRadius: "10px",
    background: "#f8fbff",
  },

  expectItem: {
    flex: 1,
    textAlign: "center",
    padding: "15px",
  },

  iconCircle: {
    width: "50px",
    height: "50px",
    margin: "0 auto 10px",
    objectFit: "contain",
  },

  expectItemTitle: {
    color: "#0E176D",
    fontWeight: "bold",
    fontSize: "13px",
    lineHeight: "18px",
  },

  expectDesc: {
    fontSize: "12px",
    color: "#343F88",
    lineHeight: "18px",
  },

  verticalDivider: {
    width: "1px",
    background: "#dbe3f0",
  },

  sectionTitle: {
    marginTop: "20px",
    fontWeight: "bold",
    color: "#0E176D",
  },

  label: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#0E176D",
    display: "block",
    marginTop: "12px",
  },

  input: {
    width: "100%",
    padding: "12px",
    marginTop: "6px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  dropdownHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
    marginTop: "15px",
    borderTop: "1px solid #e5e7eb",
    borderBottom: "1px solid #e5e7eb",
    cursor: "pointer",
  },

  dropdownTitle: {
    color: "#1f5fbf",
    fontWeight: "bold",
  },

  dropdownSubText: {
    fontSize: "11px",
    color: "#666",
    marginTop: "4px",
  },

  arrow: {
    fontSize: "12px",
  },

  termsBox: {
    background: "#f1f5fb",
    padding: "12px",
    fontSize: "12px",
    color: "#343F88",
    lineHeight: "20px",
  },

  checkboxRow: {
    marginTop: "15px",
    display: "flex",
    gap: "10px",
    alignItems: "flex-start",
  },

  checkboxText: {
    fontSize: "12px",
    color: "#0E176D",
    lineHeight: "20px",
    marginTop :"-4px"
  },

  link: {
    color: "#1f5fbf",
    textDecoration: "underline",
  },

  signatureTitle: {
    marginTop: "18px",
    fontWeight: "bold",
    color: "#0E176D",
  },

  canvas: {
    width: "100%",
    height: "120px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    marginTop: "10px",
    background: "#fff",
    touchAction: "none",
    display: "block",
  },

  clearBtn: {
    marginTop: "8px",
    fontSize: "12px",
    color: "#1f5fbf",
    background: "none",
    border: "none",
    cursor: "pointer",
  },

  button: {
    width: "100%",
    padding: "14px",
    background: "#11999f",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    marginTop: "15px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  labelnew: {
    fontSize: "12px",
    color: "#666",
    lineHeight: "18px",
    display: "block",
    marginTop: "15px",
    textAlign: "center",
  },

  nameRow: {
    display: "flex",
    gap: "20px",
    width: "100%",
    marginBottom: "10px",
  },
  
  fieldGroup: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

   emaillabel: {
    fontSize: "11px",
    color: "#666",
    lineHeight: "16px",
  },
};

const mobileCss = `
@media only screen and (max-width: 768px) {

  body {
    overflow-x: hidden;
  }

  .expect-container {
    flex-direction: column !important;
  }

  .divider-mobile {
    width: 100% !important;
    height: 1px !important;
  }

  .checkbox-mobile {
    align-items: flex-start !important;
  }
}
`;